import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IAppointmentScheduleModel {
  label: string;
}

export type AppointmentScheduleModel = ITypedModel<IAppointmentScheduleModel>;

angular.module('capability-ng-scheduler').factory('ngAppointmentScheduleModel', () => {
  return new Model<IAppointmentScheduleModel>({
    label: 'Schedule an Appointment'
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/models/appointment_schedule_model.ts